import React from "react";
import { cn } from "../../lib/utils";
import Mixpanel from "../../lib/mixpanel";

export function Contact({ className, ...props }) {
  const handleSocialClick = (platform, href, description, event) => {
    switch (platform.toLowerCase()) {
      case "email":
        Mixpanel.trackEmailClick({
          destination: href,
          description: description,
          section: "contact_page",
        });
        break;
      case "github":
        Mixpanel.trackGithubClick({
          destination: href,
          description: description,
          section: "contact_page",
        });
        break;
      case "linkedin":
        Mixpanel.trackLinkedInClick({
          destination: href,
          description: description,
          section: "contact_page",
        });
        break;
      case "x":
        Mixpanel.trackXClick({
          destination: href,
          description: description,
          section: "contact_page",
        });
        break;
      default:
        Mixpanel.track(`${platform} BTN Click`, {
          platform: platform.toLowerCase(),
          destination: href,
          contact_method: platform.toLowerCase(),
          description: description,
          section: "contact_page",
          action: "social_link_click",
        });
    }

    event.preventDefault();
    setTimeout(() => {
      if (href.startsWith("mailto:")) {
        window.location.href = href;
      } else {
        window.open(href, "_blank", "noopener,noreferrer");
      }
    }, 100);
  };

  const socialLinks = [
    {
      href: "mailto:connect@krushil.com",
      label: "Email",
      description: "connect@krushil.com",
    },
    {
      href: "https://github.com/krushil1",
      label: "GitHub",
      description: "krushil1",
    },
    {
      href: "https://linkedin.com/in/krushil-amrutiya",
      label: "LinkedIn",
      description: "krushil-amrutiya",
    },
    {
      href: "https://x.com/krushil_a",
      label: "X",
      description: "@krushil_a",
    },
  ];

  return (
    <section
      id="contact"
      className={cn(
        "mx-auto w-full max-w-[40rem] px-6 pt-28 pb-16 sm:pt-36 sm:pb-24",
        className
      )}
      {...props}
    >
      <h1 className="text-3xl sm:text-[2.5rem] font-medium tracking-[-0.03em] text-darkgray">
        Contact
      </h1>
      <p className="mt-4 text-[16px] sm:text-[17px] leading-relaxed text-gray">
        Got an idea? Let's build it.
      </p>

      <ul className="mt-12 border-t border-border">
        {socialLinks.map((link) => (
          <li key={link.label} className="border-b border-border">
            <a
              href={link.href}
              target={link.href.startsWith("mailto:") ? "_self" : "_blank"}
              rel={
                link.href.startsWith("mailto:")
                  ? undefined
                  : "noopener noreferrer"
              }
              onClick={(event) =>
                handleSocialClick(
                  link.label,
                  link.href,
                  link.description,
                  event
                )
              }
              className="group flex items-baseline justify-between gap-4 py-4 focus-ring rounded-sm"
              aria-label={link.label}
            >
              <span className="text-[15px] text-gray">{link.label}</span>
              <span className="text-[15px] text-darkgray underline-offset-4 group-hover:underline">
                {link.description}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
